<template>
  <div class="mx-4 mb-4">
    <div class="mb-3 mt-4" style="position: relative">
      <v-layout wrap>
        <v-flex xs12 sm6
          ><span class="main-title">SUMMARY | &nbsp;</span>
          <span class="submain-title">Customer report</span></v-flex
        >
        <v-flex
          xs12
          sm6
          style="display:flex;align-items:center;justify-content:flex-end"
        >
          <download-excel
            :data="export_customer_report_list"
            :fields="{
              No: 'no',
              'Customer name': 'user_full_name',
              'Tel.': 'user_tel',
              'Earn point': 'user_point',
              'Food/Free/Mes': 'user_order_count',
            }"
            :name="
              'CustomerReport_' +
                search_config.datetime_start +
                '_to_' +
                search_config.datetime_end +
                '.xls'
            "
          >
            <v-btn flat> <v-icon large color="black">print</v-icon>.xls </v-btn>
          </download-excel>
          <download-excel
            type="csv"
            :data="export_customer_report_list"
            :fields="{
              No: 'no',
              'Customer name': 'user_full_name',
              'Tel.': 'user_tel',
              'Earn point': 'user_point',
              'Food/Free/Mes': 'user_order_count',
            }"
            :name="
              'CustomerReport_' +
                search_config.datetime_start +
                '_to_' +
                search_config.datetime_end +
                '.csv'
            "
          >
            <v-btn flat> <v-icon large color="black">print</v-icon>.csv </v-btn>
          </download-excel></v-flex
        ></v-layout
      >
    </div>

    <searchDateStartToEnd
      :searching="searching"
      @search="searchList()"
      action_method="fetchCustomerReport"
    />
    <customerReportList />
  </div>
</template>

<script>
import { mapState } from "vuex";
import searchDateStartToEnd from "@/components/back-office/Report/SearchBar/SearchDateStartToEnd";
import customerReportList from "@/components/back-office/Report/CustomerReportList";
export default {
  data() {
    return {
      searching: false,
    };
  },
  components: {
    customerReportList,
    searchDateStartToEnd,
  },
  destroyed() {
    if (this.$route.name != "DetailCustomerReport") {
      this.$store.commit("fetchCustomerReport/resetState");
    }
  },
  methods: {
    async searchList() {
      this.searching = true;
      if (
        this.$store.state.fetchCustomerReport.config_path.district_id[0] == 0
      ) {
        await this.$store.dispatch(
          "fetchCustomerReport/fetchReportList",
          this.$store.state.fetchCustomerReport.config_path
        );
      } else {
        await this.$store.dispatch(
          "fetchCustomerReport/fetchReportListByDistrict"
        );
      }
      this.searching = false;
    },
  },
  computed: {
    ...mapState({
      export_customer_report_list: (state) =>
        state.fetchCustomerReport.export_customer_report_list,
      search_config: (state) => state.fetchCustomerReport.clone_config_path,
    }),
  },
  mounted() {
    const path = [
      {
        text: "Select province",
        disabled: false,
        href: "/weserve_admin_login/select/",
      },
      {
        text: "Select service",
        disabled: false,
        href: "/weserve_admin_login/control/" + this.$route.params.province,
      },
      {
        text: "Dashboard report",
        disabled: false,
        href:
          "/weserve_admin_login/control/" +
          this.$route.params.province +
          "/report/main_dashboard",
      },
      {
        text: "Customer report",
        disabled: true,
      },
    ];
    this.$store.commit("backOffice/saveRecentRoute", path);
  },
};
</script>

<style scoped>
.main-title {
  font-size: 22px;
  font-weight: bold;
}
.submain-title {
  font-size: 20px;
  color: #707070;
}
</style>
